import { render } from "./ModalLockerDefectForm.vue?vue&type=template&id=b0ca4044"
import script from "./ModalLockerDefectForm.vue?vue&type=script&lang=js"
export * from "./ModalLockerDefectForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__